import { Body, Heading } from '@depop/web-thrift-ui/Typography';
import { useTranslations } from 'next-intl';

import styles from './styles.module.css';

import { ExtendedLink } from '@/components/ExtendedLink';
import { HELP_ARTICLES } from '@/constants/helpUrls';
import { secondaryNavigation } from '@/constants/secondaryNavigation';
import { useConsentManager } from '@/modules/consent/hooks/useConsentManager';
import { isInHiddenConsentRegime } from '@/modules/consent/utils/isInHiddenConsentRegime';

type Props = {
  onCookiesClick: () => void;
};

export function SecondaryNav({ onCookiesClick }: Props) {
  const t = useTranslations('common');
  const { airgap } = useConsentManager();

  const showCookieButton = airgap && !isInHiddenConsentRegime(airgap);

  return (
    <>
      <Heading variant="sm" className={styles.navTitle}>
        {t('Nav.SecondaryNavTitle')}
      </Heading>
      <ul className={styles.navSecondaryList}>
        {secondaryNavigation.map((item, index) => {
          if (item.asAnchor) {
            return (
              <li className={styles.navListItem} key={index}>
                <a
                  className={styles.navLink}
                  href={item.link}
                  target={item.external ? '_blank' : undefined}
                  rel={item.rel ? item.rel : undefined}
                >
                  <Body variant="sm-regular">
                    {item.translation ? t(item.translation) : item.title}
                  </Body>
                </a>
              </li>
            );
          }
          return (
            <li className={styles.navListItem} key={index}>
              <ExtendedLink
                className={styles.navLink}
                href={item.link}
                prefetch={false}
                target={item.external ? '_blank' : undefined}
                rel={item.rel ? item.rel : undefined}
              >
                <Body variant="sm-regular">
                  {item.translation ? t(item.translation) : item.title}
                </Body>
              </ExtendedLink>
            </li>
          );
        })}
        {showCookieButton ? (
          <li
            className={styles.navListItem}
            key="efd99692-f349-4da5-8087-bded7ce9431f"
          >
            <button className={styles.cookiesButton} onClick={onCookiesClick}>
              <Body variant="sm-regular">{t('Nav.Cookies')}</Body>
            </button>
          </li>
        ) : (
          <li
            className={styles.navListItem}
            key="efd99692-f349-4da5-8087-bded7ce9431f"
          >
            <a
              className={styles.navLink}
              href={HELP_ARTICLES.PRIVACY_POLICY}
              target="_blank"
              rel="noopener"
            >
              <Body variant="sm-regular">{t('Nav.Cookies')}</Body>
            </a>
          </li>
        )}
      </ul>
    </>
  );
}
